"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListPrice = void 0;
const react_1 = __importDefault(require("react"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const html_widget_1 = require("../html-widget");
const icons_1 = require("../icons");
const responsive_popover_and_bottomsheet_toggler_1 = require("../responsive-popover-and-bottomsheet-toggler");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const ListPrice = (props) => {
    const { currencySymbol, listPrice, basisPriceReplacementText = '', subscriptionTermString = '', typographySize = 'base', label, currencySymbolPosition = 'left' } = props;
    const listPriceToDisplay = currencySymbolPosition === 'left'
        ? `${currencySymbol}${listPrice}${subscriptionTermString}`
        : `${listPrice}${currencySymbol}${subscriptionTermString}`;
    if (basisPriceReplacementText) {
        return (react_1.default.createElement(styles_1.ListPriceDiv, { topSpacing: !!props.topSpacing },
            react_1.default.createElement(themed_text_1.ThemedSpan, { color: "secondary", font: typographySize }, basisPriceReplacementText)));
    }
    return listPrice ? (react_1.default.createElement(styles_1.ListPriceDiv, { topSpacing: !!props.topSpacing },
        label && (react_1.default.createElement(themed_text_1.ThemedSpan, { color: "secondary", font: typographySize },
            label,
            "\u00A0")),
        react_1.default.createElement(themed_text_1.ThemedSpan, { color: "secondary", font: typographySize, style: { textDecoration: 'line-through' } }, listPriceToDisplay),
        props.popOverContent && (react_1.default.createElement(styles_1.StyledDiv, null,
            react_1.default.createElement(responsive_popover_and_bottomsheet_toggler_1.ResponsivePopoverAndBottomSheetToggler, { dataCy: "list-price-icon", primaryContent: react_1.default.createElement(PopoverPrimaryContent, Object.assign({}, props)), innerContent: react_1.default.createElement(InnerContent, Object.assign({}, props)) }))))) : null;
};
exports.ListPrice = ListPrice;
const PopoverPrimaryContent = ({ typographySize = 'base' }) => {
    return (react_1.default.createElement(themed_text_1.ThemedAnchor, { color: "secondary", "aria-label": 'Learn more' },
        react_1.default.createElement(icons_1.RioAlertIcon, { alertType: "information", size: getIconSize(typographySize), fillColor: monera_app_core_1.Gray_700 })));
};
const InnerContent = ({ popOverContent }) => (react_1.default.createElement(html_widget_1.HtmlWidget, { isDangerousHtml: true, html: popOverContent }));
const getIconSize = (size) => {
    switch (size) {
        case 'micro':
        case 'mini':
        case 'small':
        case 'base':
        case 'basePlus':
        default:
            return 12;
        case 'medium':
        case 'mediumPlus':
            return 16;
        case 'large':
        case 'extraLarge':
        case 'doubleLarge':
            return 20;
    }
};
__exportStar(require("./types"), exports);
